import { useEffect, useState } from "react";
import { SlidersHorizontal, X } from "lucide-react";

/** Desktop: inline toolbar. Phone: a "Filters" button that slides the same
 *  controls up as a bottom sheet (single DOM node, so picker state persists). */
export default function FilterBar({ summary, children, testId = "filter-toolbar" }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="mobile-filters-button"
        className="md:hidden w-full flex items-center justify-between gap-3 px-4 py-3 border border-[#0a0a0a] bg-[#ede8dc] text-left"
      >
        <span className="flex items-center gap-2 min-w-0">
          <SlidersHorizontal size={14} className="shrink-0" />
          <span className="bm-eyebrow">Filters</span>
          {summary && <span className="font-mono-bm text-xs text-neutral-600 truncate">· {summary}</span>}
        </span>
        <span className="bm-eyebrow text-[#c72c2c] shrink-0">Edit</span>
      </button>

      {open && (
        <div
          className="md:hidden fixed inset-0 z-40 bg-black/60"
          onClick={() => setOpen(false)}
          data-testid="mobile-filters-backdrop"
        />
      )}

      <div
        data-testid={testId}
        className={
          "flex flex-wrap gap-3 items-end p-3 border border-[#0a0a0a] bg-[#ede8dc] " +
          "max-md:fixed max-md:inset-x-0 max-md:bottom-0 max-md:z-50 max-md:flex-col max-md:items-stretch " +
          "max-md:gap-5 max-md:p-5 max-md:pb-8 max-md:border-x-0 max-md:border-b-0 max-md:border-t-2 " +
          "max-md:transition-transform max-md:duration-300 " +
          (open ? "" : "max-md:translate-y-full max-md:invisible")
        }
      >
        <div className="md:hidden flex items-center justify-between -mb-2">
          <span className="bm-eyebrow">Filters</span>
          <button
            type="button"
            onClick={() => setOpen(false)}
            data-testid="mobile-filters-close"
            className="inline-flex items-center gap-1 bm-eyebrow px-3 py-2 border border-[#0a0a0a] bg-[#0a0a0a] text-[#f5f2eb]"
          >
            <X size={12} /> Done
          </button>
        </div>
        {children}
      </div>
    </>
  );
}
